import { a as _sfc_main } from "../../MalarkeyAttachmentPane.vue_vue_type_script_lang-d0f606dc.mjs";
import { resolveComponent, resolveDirective, openBlock, createElementBlock, mergeProps, withDirectives, createElementVNode, createBlock, createCommentVNode, Fragment, renderList } from "vue";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-3194dc60.mjs";
import "../../i18n-35335a5c.mjs";
import "../../index-38c53cf2.mjs";
import "../../_i18n-e414d464.mjs";
import "../../index-64135f7d.mjs";
import "../../index-703c58ee.mjs";
import "../../malarkeyTwilioAdapter-1c296255.mjs";
import "../../index-13be80af.mjs";
import "../../_commonjsHelpers-ca272635.mjs";
import "../../_debug-8b5c3032.mjs";
import "joi";
import "../../helpers-674591c1.mjs";
import "../../event-socket/malarkeyEventSocketAdapter.es.js";
import "../../otpauth.esm-675c01d0.mjs";
import "../../sudo-bad5b55e.mjs";
import "../../index-fd2245c5.mjs";
import "../../_common-fcf3ef61.mjs";
import "../../MalarkeyContactAvatar-1b079ba3.mjs";
import "../../_density-8094aebe.mjs";
import "../../MPasswordField.vue_vue_type_script_lang-baf1023a.mjs";
import "../../_VTextField-74fe2c1a.mjs";
import "../../index-dbde2d54.mjs";
import "../../_proxiedModel-031e293c.mjs";
import "../../flow-501bd5ba.mjs";
import "../../MalarkeyContactRosterItem.vue_vue_type_script_lang-89c5ac30.mjs";
import "../../_VListItem-508e4b13.mjs";
import "../../MalarkeyContactSearchItem.vue_vue_type_script_lang-f1ada97c.mjs";
import "../../MalarkeyConversationListItem.vue_vue_type_script_lang-3da40755.mjs";
import "../../theme-96176369.mjs";
import "../../getCurrentInstance-eec76705.mjs";
import "./MalarkeyChatInputForm.es.js";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_progress_linear = resolveComponent("v-progress-linear");
  const _component_MalarkeyChatMessagePaneItem = resolveComponent("MalarkeyChatMessagePaneItem");
  const _directive_intersect = resolveDirective("intersect");
  const _directive_mutate = resolveDirective("mutate");
  return openBlock(), createElementBlock("div", mergeProps({ ref: "wrapper" }, _ctx.wrapperBindings), [
    withDirectives((openBlock(), createElementBlock("div", mergeProps({ ref: "scrollable" }, _ctx.scrollableBindings), [
      withDirectives(createElementVNode("div", mergeProps({ ref: "topBar" }, _ctx.topBarBindings), null, 16), [
        [_directive_intersect, { handler: _ctx.onMessageListTopIntersect }]
      ]),
      createElementVNode("div", mergeProps({ ref: "loaderBar" }, _ctx.loaderBarBindings), [
        _ctx.isLoading ? (openBlock(), createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          height: "2",
          color: "primary"
        })) : createCommentVNode("", true)
      ], 16),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.sortedMessages, (msg, i) => {
        var _a;
        return openBlock(), createBlock(_component_MalarkeyChatMessagePaneItem, {
          key: `msg-${msg.conversation.sid}-${msg.index}-${(_a = msg.dateUpdated) == null ? void 0 : _a.valueOf()}`,
          message: msg,
          participants: _ctx.participants,
          isLastMessageBySameSender: _ctx.getIsLastMessageBySameSender(msg, i),
          archived: _ctx.archived,
          reactions: _ctx.messageReactionsByMessageSid[msg.sid],
          onSeen: _ctx.onMessageSeen,
          "onPreview:loaded": _ctx.onMediaPreviewLoaded
        }, null, 8, ["message", "participants", "isLastMessageBySameSender", "archived", "reactions", "onSeen", "onPreview:loaded"]);
      }), 128))
    ], 16)), [
      [
        _directive_mutate,
        _ctx.onScrollableMutated,
        void 0,
        {
          attr: true,
          child: true,
          immediate: true
        }
      ]
    ])
  ], 16);
}
const MalarkeyChatMessagePane = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "MalarkeyChatMessagePane.vue"]]);
export {
  MalarkeyChatMessagePane as default
};
//# sourceMappingURL=MalarkeyChatMessagePane.es.js.map
